/* 
 * Export component file to be used on project
*/

import MenuLogout from './MenuLogout.js';
export default MenuLogout;
